import TechDetector from './utils/tech-detector';
import ConsoleCapture from './utils/console-capture';
import BrowserDebugCollector from './utils/browser-debug-info';
class DeviceInfo {
    constructor() {
        this.techDetector = new TechDetector();
        this.consoleCapture = new ConsoleCapture(100); // Keep last 100 logs
        this.debugCollector = new BrowserDebugCollector();
        this.info = this.collect();
    }
    /**
     * Start capturing console logs and errors
     */
    startConsoleCapture() {
        this.consoleCapture.startCapture();
    }
    /**
     * Stop capturing console logs and errors
     */
    stopConsoleCapture() {
        this.consoleCapture.stopCapture();
    }
    collect() {
        // Check if we're in a browser environment
        if (typeof window === 'undefined' || typeof navigator === 'undefined') {
            return {
                browser: 'SSR',
                os: 'SSR',
                screenResolution: '0x0',
                viewport: '0x0',
                url: '',
                timestamp: new Date().toISOString(),
                userAgent: 'SSR',
                language: 'en-US',
                platform: 'SSR',
                cookiesEnabled: false,
                onLine: false
            };
        }
        return {
            browser: this.getBrowserInfo(),
            os: this.getOSInfo(),
            screenResolution: `${window.screen.width}x${window.screen.height}`,
            viewport: `${window.innerWidth}x${window.innerHeight}`,
            url: window.location.href,
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent,
            language: navigator.language,
            platform: navigator.platform,
            cookiesEnabled: navigator.cookieEnabled,
            onLine: navigator.onLine
        };
    }
    getBrowserInfo() {
        const ua = navigator.userAgent;
        let browserName = 'Unknown';
        let browserVersion = 'Unknown';
        if (ua.indexOf('Firefox') > -1) {
            browserName = 'Firefox';
            browserVersion = ua.match(/Firefox\/(\d+\.\d+)/)?.[1] || 'Unknown';
        }
        else if (ua.indexOf('Chrome') > -1 && ua.indexOf('Edg') === -1) {
            browserName = 'Chrome';
            browserVersion = ua.match(/Chrome\/(\d+\.\d+)/)?.[1] || 'Unknown';
        }
        else if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
            browserName = 'Safari';
            browserVersion = ua.match(/Version\/(\d+\.\d+)/)?.[1] || 'Unknown';
        }
        else if (ua.indexOf('Edg') > -1) {
            browserName = 'Edge';
            browserVersion = ua.match(/Edg\/(\d+\.\d+)/)?.[1] || 'Unknown';
        }
        return `${browserName} ${browserVersion}`;
    }
    getOSInfo() {
        const ua = navigator.userAgent;
        let os = 'Unknown';
        if (ua.indexOf('Win') > -1) {
            os = 'Windows';
        }
        else if (ua.indexOf('Mac') > -1) {
            os = 'macOS';
        }
        else if (ua.indexOf('Linux') > -1) {
            os = 'Linux';
        }
        else if (ua.indexOf('Android') > -1) {
            os = 'Android';
        }
        else if (ua.indexOf('iOS') > -1 || ua.indexOf('iPhone') > -1 || ua.indexOf('iPad') > -1) {
            os = 'iOS';
        }
        return os;
    }
    refresh() {
        this.info = this.collect();
        return this.info;
    }
    get() {
        return this.info;
    }
    /**
     * Get complete device info with extended debugging data
     */
    async getExtended() {
        const baseInfo = this.collect();
        // Collect extended debugging information
        const [technologies, debugInfo] = await Promise.all([
            Promise.resolve(this.techDetector.detect()),
            this.debugCollector.collect()
        ]);
        // Get console logs if capturing is active
        const consoleLogs = this.consoleCapture.isActive()
            ? this.consoleCapture.getData()
            : undefined;
        return {
            ...baseInfo,
            technologies,
            consoleLogs,
            debugInfo
        };
    }
    /**
     * Get console capture instance for manual control
     */
    getConsoleCapture() {
        return this.consoleCapture;
    }
}
export default DeviceInfo;
//# sourceMappingURL=device-info.js.map